<template>
  <PFormField
    v-if="retroactive"
    label="Datum terugwerkende kracht"
    class="model-edit-form-retroactive-pricing min-h-20"
  >
    <template v-if="$slots.subtitle" #description><slot name="subtitle" /></template>
    <div class="absolute pr-5">
      <PInputDate v-model="retroactiveDate" :teleport="false" ref="inputDatepicker" />
    </div>
  </PFormField>
  <PCheckbox
    v-model="retroactive"
    @change="onChooseRetroactive"
    as="label"
    v-else
    class="model-edit-form-retroactive-pricing cursor-pointer space-x-2"
  >
    <template #label>
      <span class="text-sm">{{ priceLabel }} met terugwerkende kracht doorvoeren</span>
    </template>
  </PCheckbox>
</template>

<script setup lang="ts">
import { computed, nextTick, ref, watch } from "vue"
import PInputDate from "@/components/form/PInputDate.vue"
import moment, { type Moment } from "moment"
import PCheckbox from "@/components/form/PCheckbox.vue"
import PFormField from "@/components/form/PFormField.vue"

const retroactiveDate = defineModel<Moment>({ required: true })

const props = defineProps<{
  priceType: "purchase" | "sale"
}>()

const priceLabel = computed(() =>
  props.priceType === "purchase" ? "Inkoopprijzen" : "Verkoopprijzen"
)

const retroactive = ref(false)

watch(retroactiveDate, (val) => {
  if (!val) {
    retroactive.value = false
  }
})

function onChooseRetroactive() {
  retroactive.value = true
  retroactiveDate.value = moment().startOf("day")
  nextTick(() => {
    inputDatepicker.value!.openMenu()
  })
}

const inputDatepicker = ref()
</script>

<style scoped></style>
